import { CommentOutlined, LinkOutlined, SmileOutlined, UserOutlined } from '@ant-design/icons';
import { Attachments, Bubble, Prompts, Sender, useXAgent, useXChat, Welcome } from '@ant-design/x';
import { Button, Flex, FloatButton, type GetProp, message } from 'antd';
import React from 'react';

const sleep = () => new Promise((resolve) => setTimeout(resolve, 1000));

const roles: GetProp<typeof Bubble.List, 'roles'> = {
  user: {
    placement: 'end',
    avatar: { icon: <UserOutlined />, style: { background: '#87d068' } },
  },
  text: {
    placement: 'start',
    avatar: { icon: <UserOutlined />, style: { background: '#fde3cf' } },
    typing: true,
  },
  suggestion: {
    placement: 'start',
    avatar: { icon: <UserOutlined />, style: { visibility: 'hidden' } },
    variant: 'borderless',
    messageRender: (content) => (
      <Prompts
        vertical
        items={(content as any as string[]).map((text) => ({
          key: text,
          icon: <SmileOutlined style={{ color: '#FAAD14' }} />,
          description: text,
        }))}
      />
    ),
  },
};

type AgentUserMessage = {
  type: 'user';
  content: string;
};

type AgentAIMessage = {
  type: 'ai';
  content?: string;
  list?: (
    | {
        type: 'text';
        content: string;
      }
    | {
        type: 'suggestion';
        content: string[];
      }
  )[];
};

type AgentMessage = AgentUserMessage | AgentAIMessage;

type BubbleMessage = {
  role: string;
};

const ChatDom = (props: any) => {
  const { onSetChatVisible } = props;
  const [content, setContent] = React.useState('');
  // const [drawerOpen, setDrawerOpen] = useState(false);

  const onClose = () => {
    setDrawerOpen(false);
  };

  // Agent for request
  const [agent] = useXAgent<AgentMessage>({
    request: async ({ message }, { onSuccess }) => {
      await sleep();

      const { content = '' } = message || {};
      const keyword = content?.length > 5 ? content?.substring(0, 3) + '...' : content;

      onSuccess({
        type: 'ai',
        list: [
          {
            type: 'text',
            content: `我猜你想要?`,
          },
          {
            type: 'suggestion',
            content: [/*`Look at: ${content}`,*/ `查询: ${keyword}`, `试一试: ${keyword}`],
          },
        ],
      });
    },
  });

  // Chat messages
  const { onRequest, parsedMessages } = useXChat<AgentMessage, BubbleMessage>({
    agent,

    // defaultMessages: [
    //   {
    //     id: 'init',
    //     message: {
    //       type: 'ai',
    //       content: 'Hello, what can I do for you?',
    //     },
    //     status: 'success',
    //   },
    // ],

    requestPlaceholder: {
      type: 'ai',
      content: 'Waiting...',
    },

    // Convert AgentMessage to BubbleMessage
    parser: (agentMessages) => {
      const list = agentMessages.content ? [agentMessages] : (agentMessages as AgentAIMessage).list;

      return (list || []).map((msg) => ({
        role: msg.type,
        content: msg.content,
      }));
    },
  });
  return (
    <>
      <FloatButton
        style={{ bottom: '100px' }}
        icon={<CommentOutlined color={'white'} />}
        onClick={() => onSetChatVisible(true)}
        // tooltip={<>Ask me</>}
      />
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        {/* 上面部分 */}
        <div
          style={{
            flex: 1, // 占据剩余空间
            overflow: 'auto', // 如果内容溢出，可以滚动
            background: '#f0f2f5', // 浅灰色背景，便于区分
            padding: '10px',
          }}
        >
          <Flex vertical gap="small">
            {!parsedMessages?.length && (
              <Welcome
                icon="https://mdn.alipayobjects.com/huamei_iwk9zp/afts/img/A*s5sNRo5LjfQAAAAAAAAAAAAADgCCAQ/fmt.webp"
                title="您好，我是您的AI助手"
                description="让我们开始愉快的交流吧~"
              />
            )}
            <Bubble.List
              roles={roles}
              style={{ maxHeight: '100%' }}
              items={parsedMessages.map(({ id, message, status }) => ({
                key: id,
                loading: status === 'loading',
                ...message,
              }))}
            />
          </Flex>
        </div>

        {/* 下面部分 */}
        <div
          style={{
            minHeight: '100px', // 设置最低高度
            color: 'white',
            padding: '10px',
            background: '#f0f2f5', // 浅灰色背景，便于区分
          }}
        >
          <Sender
            loading={agent.isRequesting()}
            value={content}
            onChange={setContent}
            onSubmit={(nextContent) => {
              onRequest({
                type: 'user',
                content: nextContent,
              });
              setContent('');
            }}
            prefix={
              <Attachments
                beforeUpload={() => false}
                onChange={({ file }) => {
                  message.info(`上传的文件是: ${file.name}`);
                }}
                // getDropContainer={() => (fullScreenDrop ? document.body : divRef.current)}
                // placeholder={{
                //   icon: <CloudUploadOutlined />,
                //   title: 'Drag & Drop files here',
                //   description: 'Support file type: image, video, audio, document, etc.',
                // }}
              >
                <Button type="text" icon={<LinkOutlined />} />
              </Attachments>
            }
          />
        </div>
      </div>
    </>
  );
};

export default ChatDom;
